module.exports = __webpack_public_path__ + "f62b2bed519e2692b01677141d28df4e.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/diamond-photo/img/large_180x180_icon.png
// module id = 300
// module chunks = 0